<h2 mat-dialog-title>{{ data.title }}</h2>
<div mat-dialog-content>
	<div class="text-xl">{{ data.message }}</div>
</div>
<div
	mat-dialog-actions
	[align]="'end'"
	style="margin-top: 32px">
	<button
		mat-button
		[mat-dialog-close]="false">
		{{ "DELETE-MODAL_CANCEL" | translate }}
	</button>
	<button
		mat-raised-button
		color="warn"
		[mat-dialog-close]="true">
		{{ data.positiveButton }}
	</button>
</div>
